module.exports = __webpack_public_path__ + "img/jo2.c46a9976.png";